module.exports = __webpack_public_path__ + "static/img/cooperation_2.1535c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/cooperation_2.png
// module id = 9YlE
// module chunks = 1